"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 50,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5649 23.6827C29.8577 23.3898 29.8577 22.9149 29.5649 22.622C29.272 22.3291 28.7971 22.3291 28.5042 22.622L24.0932 27.0331L22.1529 25.0928C21.86 24.7999 21.3851 24.7999 21.0922 25.0928C20.7993 25.3857 20.7993 25.8605 21.0922 26.1534L23.5478 28.609C23.5526 28.6141 23.5576 28.6192 23.5626 28.6243C23.7183 28.7799 23.9253 28.8528 24.1291 28.8431C24.309 28.8345 24.4863 28.7616 24.6237 28.6242C24.6285 28.6194 24.6332 28.6146 24.6378 28.6097L29.5649 23.6827Z",
  fill: "#121213"
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: "25.002",
  cy: "25",
  r: "8.49805",
  stroke: "#737F8F"
}));

exports.default = _default;